<template>
    <div v-if="isLoaded" class="page-wrap">
        <div class="page-bar">
            <div>
                <div class="page-bar-sub">Work</div>
                <div class="page-bar-main"><textarea v-model="name" @input="debounceSubmit()" style="background:none;border:none;padding:0;color:white;font-size:24px;font-weight:bold;margin:0;height: auto;width: auto; field-sizing: content; min-inline-size: 20px;"></textarea></div>
            </div>
        </div>
        <div :class="$store.state.routeLoaded ? 'slide-up view' : 'hide'">
            <div class="playbook">
                <!--
                <div class="form-wrapper" style="margin-bottom: 10px">
                    <div>
                        <h3>Name</h3>
                        <input style="margin-bottom:0" type="text" v-model="name" />
                    </div>
                    <div class="fixed-submit">
                        <input :class="disableButton ? 'disable-button' : ''" @click.prevent="submit()" type="submit" value="Submit" />
                    </div>
                </div>
                -->

                <div v-if="$store.state.user.role == 'Admin'" style="display: flex;flex-wrap: wrap;margin-top:15px">
                    <div @click="editUsers()" class="add-btn" style="margin-right:10px">Edit Users</div>
                </div>

                <div v-if="isTemplate && $store.state.user.companyID == 1" style="margin: 15px 0;font-size:20px;color: red">
                    <b>TEMPLATE - DO NOT EDIT</b>
                </div>

                <div v-if="companyScorecard" class="item-form-tabs" style="margin-top:20px">
                    <div v-for="(month, i) in months" :key="i" :class="month.selected ? 'item-tab-selected' : ''" @click="companyScorecardMonthChange(month)">{{ month.name }}</div>
                </div>

                <div v-if="saving" style="font-weight:bold">Saving...</div>
                <div v-else-if="saved" style="color:green;font-weight:bold">All Changes Saved.</div>
                <div v-else>&nbsp;</div>

                <div v-if="colsToHide.length" style="margin-top:15px">
                    <a @click.prevent="() => { colsToHide = [] }">Show All Cols</a>
                </div>

                <div id="playbook-sheet-wrap" class="playbook-sheet-wrap company-sheet-wrap">
                    <table id="playbook-sheet" :class="companyScorecard ? 'playbook-sheet scorecard-playbook-sheet' : 'playbook-sheet'">
                        <tbody>
                            <tr v-for="(row, i) in sheetJSON.rows" :key="'r'+i">
                                <td :style="(companyScorecard && j == 58 && i != 0) ? 'background:'+col.text : ''" v-for="(col, j) in row" :key="'c'+j" v-show="!colsToHide.includes(j)" @contextmenu="cellRightClick($event, i, j)">
                                    
                                    <div v-if="companyScorecard && j == 58 && i != 0">
                                        <select style="width:90px;font-weight:bold;margin:0" v-model="col.text" @change="debounceSubmit()">
                                            <option value="Green">Green</option>
                                            <option value="Yellow">Yellow</option>
                                            <option value="Red">Red</option>
                                        </select>
                                    </div>
                                    <div v-else>
                                        <div v-if="col.calculatedValue" style="font-size: 16px">{{ col.calculatedValue }}</div>
                                        <div v-else><textarea :style="col.bold ? 'font-weight:bold' : ''" v-model="col.text" @input="debounceSubmit()"></textarea></div>
                                        <div v-if="col.secondLine">{{ col.secondLine }}</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div v-if="showRightClickMenu" class="form-wrapper link-pop" :style="`top: ${rightClickY - 20}px; left: ${rightClickX}px`">
            <span class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="() => { showRightClickMenu = false }">&times;</button>
            </span>
            <div><a @click.prevent="hideCol(rightClickCellCol)">Hide Col</a></div>
            <div><a @click.prevent="addRow(rightClickCellRow)">Add Row Above</a></div>
            <div><a @click.prevent="addRow(rightClickCellRow + 1)">Add Row Below</a></div>
            <div><a @click.prevent="addCol(rightClickCellCol)">Add Col Left</a></div>
            <div><a @click.prevent="addCol(rightClickCellCol + 1)">Add Col Right</a></div>
            <div><a @click.prevent="removeRow(rightClickCellRow)">Delete Row</a></div>
            <div><a @click.prevent="removeCol(rightClickCellCol)">Delete Col</a></div>
            <div>
                <input style="margin:0" @change="debounceSubmit()" type="text" placeholder="Second Line" v-model="sheetJSON.rows[rightClickCellRow][rightClickCellCol].secondLine" />
            </div>
            <div>
                <input style="margin:0 0 5px" @change="debounceSubmit()" type="text" placeholder="Function" v-model="sheetJSON.rows[rightClickCellRow][rightClickCellCol].function" />
            </div>
            <div class="checkbox-input">
                <input @change="debounceSubmit()" type="checkbox" v-model="sheetJSON.rows[rightClickCellRow][rightClickCellCol].bold" />
                Bold
            </div>
        </div>

        <confirm-delete v-if="showConfirmColRemove" @confirm="removeColCB" @cancel="() => { showConfirmColRemove = false; }" msg="Are you sure you would like to delete this col?"/>
        <confirm-delete v-if="showConfirmRowRemove" @confirm="removeRowCB" @cancel="() => { showConfirmRowRemove = false; }" msg="Are you sure you would like to delete this row?"/>
        <select-employees v-if="showEditUsers" title="Share with" source="/api/employees/picker" :selectedIds="editUsersCurrent" @save="saveUsers" @close="() => { showEditUsers = false; }" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
import SelectEmployees from '@/components/SelectEmployees.vue';

export default defineComponent({
    name: 'CompanySheet',
    components: {
        ConfirmDelete,
        SelectEmployees,
    },
    data() {
        return {
            name: '',
            slug: '',
            editUsersCurrent: [] as any,
            showEditUsers: false,
            isLoaded: false,
            sheetJSON: {
                rows: [
                    [
                        {
                            text: 'Col 1'
                        },
                        {
                            text: 'Col 2'
                        },
                        {
                            text: 'Col 3'
                        },
                    ]
                ]
            } as any,
            disableButton: false,
            rightClickCellRow: 0,
            rightClickCellCol: 0,
            showRightClickMenu: false,
            rightClickX: 0,
            rightClickY: 0,
            rowToRemove: 0,
            colToRemove: 0,
            showConfirmRowRemove: false,
            showConfirmColRemove: false,
            submitDebounceTimer: null as any,
            saving: false,
            saved: false,
            colsToHide: [] as any,
            companyScorecard: false,
            isTemplate: false,
            months: [
                {
                    name: 'Jan',
                    selected: false
                },
                {
                    name: 'Feb',
                    selected: false
                },
                {
                    name: 'Mar',
                    selected: false
                },
                {
                    name: 'Apr',
                    selected: false
                },
                {
                    name: 'May',
                    selected: false
                },
                {
                    name: 'Jun',
                    selected: false
                },
                {
                    name: 'Jul',
                    selected: false
                },
                {
                    name: 'Aug',
                    selected: false
                },
                {
                    name: 'Sep',
                    selected: false
                },
                {
                    name: 'Oct',
                    selected: false
                },
                {
                    name: 'Nov',
                    selected: false
                },
                {
                    name: 'Dec',
                    selected: false
                },
            ]
        }
    },
    async created() {
        if(!this.$route.params.slug) {
            return;
        }

        await axios.get(`${this.$store.state.apiUrl}/api/companysheets/${this.$route.params.slug}`)
            .then(resp => {
                this.name = resp.data.Name;
                this.slug = resp.data.Slug;
                if(resp.data.SheetJSON) {
                    this.sheetJSON = JSON.parse(resp.data.SheetJSON);
                }
                if(resp.data.Template) {
                    this.isTemplate = true;
                }
            })
            .catch(e => {
                console.log(e);
            })

        if(this.sheetJSON.companyScorecard && this.name != 'Company Scorecard') {
            this.companyScorecard = true;
            const d = new Date();
            this.months[d.getMonth()].selected = true;
            this.setCompanyScorecardColumns();
        } else {
            this.calculateCellValues();
        }

        this.$store.state.routeLoaded = true;
        this.isLoaded = true;

        if(this.sheetJSON.rows.length > 14) {
            setTimeout(() => {
                const table = document.getElementById('playbook-sheet-wrap');
                if(table) {
                    this.doubleScroll(table);
                }
            }, 200)
        }
    },
    methods: {
        // Loads the employee IDs the sheet is shared with
        async editUsers() {
            await axios.get(`${this.$store.state.apiUrl}/api/companysheets/users/${this.slug}`)
                .then(resp => {
                    this.editUsersCurrent = resp.data;
                    this.showEditUsers = true;
                })
                .catch(e => {
                    alert('There was an error');
                    console.log(e);
                })
        },
        async saveUsers(employeeIDs: number[]) {
            const data = {
                slug: this.slug,
                employeeIDs
            }
            await axios.post(`${this.$store.state.apiUrl}/api/companysheets/users`, data)
                .then(() => {
                    this.showEditUsers = false;
                })
                .catch(e => {
                    alert('There was an error');
                    console.log(e);
                })
        },
        debounceSubmit() {
            this.saving = true;
            this.saved = false;
            clearTimeout(this.submitDebounceTimer);
            this.submitDebounceTimer = setTimeout(() => { this.submit(); }, 2000);
        },
        async submit() {
            this.calculateCellValues();

            const data = {
                Name: this.name,
                Slug: this.slug,
                SheetJSON: JSON.stringify(this.sheetJSON)
            }
            await axios.post(`${this.$store.state.apiUrl}/api/companysheets/update`, data)
                .then(resp => {
                    this.saving = false;
                    this.saved = true;
                })
                .catch(e => {
                    console.log(e);
                })
        },
        calculateCellValues() {
            for(const row of this.sheetJSON.rows) {
                for(const col of row) {
                    col.calculatedValue = null;
                    if(col.function) {
                        if(col.function.includes('add(')) {
                            const indicesString = col.function.replace('add(', '').replace(')', '').replace(/ /g, '');
                            const indicesArray = indicesString.split(',');
                            let total = 0;
                            for(const indexString of indicesArray) {
                                if(indexString) {
                                    const index = parseInt(indexString);
                                    const val = parseFloat(row[index].text);
                                    if(val) {
                                        total += val;
                                    }
                                }
                            }
                            col.calculatedValue = total.toLocaleString(undefined, {maximumFractionDigits:2,minimumFractionDigits:0});
                        } else if(col.function.includes('avg(')) {
                            const indicesString = col.function.replace('avg(', '').replace(')', '').replace(/ /g, '');
                            const indicesArray = indicesString.split(',');
                            let total = 0;
                            let numCols = 0;
                            for(const indexString of indicesArray) {
                                if(indexString) {
                                    const index = parseInt(indexString);
                                    const val = parseFloat(row[index].text);
                                    if(val || val === 0) {
                                        total += val;
                                        numCols++;
                                    }
                                }
                            }
                            const avg = total / (numCols || 1);
                            col.calculatedValue = avg.toLocaleString(undefined, {maximumFractionDigits:2,minimumFractionDigits:0});
                        }
                    }
                }
            }
        },
        addRow(index: any) {
            const colLength = this.sheetJSON.rows[0].length;
            const newRow = [];
            for(let i = 0; i < colLength; i++) {
                newRow.push({
                    text: ''
                })
            }
            if(index === null) {
                this.sheetJSON.rows.push(newRow);
            } else {
                this.sheetJSON.rows.splice(index, 0, newRow);
            }
            this.showRightClickMenu = false;
            this.debounceSubmit();
        },
        addCol(index: any) {
            if(index === null) {
                for(const row of this.sheetJSON.rows) {
                    const newCol = {
                        text: ''
                    }
                    row.push(newCol);
                }
            } else {
                for(const row of this.sheetJSON.rows) {
                    const newCol = {
                        text: ''
                    }
                    row.splice(index, 0, newCol);
                }
            }

            this.showRightClickMenu = false;

            setTimeout(() => {
                const table = document.getElementById('playbook-sheet-wrap');
                if(table) {
                    this.doubleScroll(table);
                }
            }, 500);

            this.debounceSubmit();
        },
        removeCol(index: number) {
            this.colToRemove = index;
            this.showConfirmColRemove = true;
        },
        removeRow(index: number) {
            this.rowToRemove = index;
            this.showConfirmRowRemove = true;
        },
        removeColCB() {
            for(const row of this.sheetJSON.rows) {
                row.splice(this.colToRemove, 1);
            }
            this.showRightClickMenu = false;
            this.showConfirmColRemove = false;
            this.debounceSubmit();
        },
        removeRowCB() {
            if(this.sheetJSON.rows.length == 1) {
                this.showRightClickMenu = false;
                return;
            }
            this.sheetJSON.rows.splice(this.rowToRemove, 1);
            this.showRightClickMenu = false;
            this.showConfirmRowRemove = false;
            this.debounceSubmit();
        },
        deleteShiftUp(row: number, col: number) {
            for(let i = row; i < this.sheetJSON.rows.length - 1; i++) {
                this.sheetJSON.rows[i][col] = this.sheetJSON.rows[i+1][col];
            }
            this.sheetJSON.rows[this.sheetJSON.rows.length - 1][col] = {
                text: ''
            }
            this.debounceSubmit();
        },
        cellRightClick(e: any, i: number, j: number) {
            e.preventDefault();
            this.rightClickX = e.clientX;
            this.rightClickY = e.clientY;
            const elBottom = this.rightClickY + 320;
            if(elBottom > window.innerHeight) {
                this.rightClickY = window.innerHeight - 320;
            }
            this.rightClickCellRow = i;
            this.rightClickCellCol = j;
            this.showRightClickMenu = true;
        },
        hideCol(index: number) {
            this.colsToHide.push(index);
            this.showRightClickMenu = false;
        },

        setCompanyScorecardColumns() {
            let month = 'Jan';
            for(let i = 0; i < this.months.length; i++) {
                if(this.months[i].selected) {
                    month = this.months[i].name;
                    break;
                }
            }
            this.colsToHide = [];
            const colsInMonth = [];
            for(let i = 0; i < 52; i++) {
                const index = i + 1;
                const colSecondLine = this.sheetJSON.rows[1][index].secondLine || '';
                if(!colSecondLine.includes(month)) {
                    this.colsToHide.push(index);
                } else {
                    colsInMonth.push(index);
                }
            }
            const addMonthString = 'add(' + colsInMonth.join(',') + ')';
            const avgMonthString = 'avg(' + colsInMonth.join(',') + ')';
            for(let i = 2; i < this.sheetJSON.rows.length; i++) {
                const row = this.sheetJSON.rows[i];
                row[53].function = addMonthString;
                row[54].function = avgMonthString;
            }
            this.calculateCellValues();
        },
        companyScorecardMonthChange(month: any) {
            for(const m of this.months) {
                m.selected = false;
            }
            month.selected = true;
            this.setCompanyScorecardColumns();
        }
    }
});
</script>